// @ts-nocheck
/* eslint-disable */
export const boldArrowLeftIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="m13.32 7.547-2.14 2.14-1.313 1.306a1.42 1.42 0 0 0 0 2.007l3.453 3.453c.453.454 1.227.127 1.227-.506V8.053c0-.64-.774-.96-1.227-.506"/></svg>`,
    name: 'bold-arrow-left' as const
};